export default "/assets/images/mila-firmware.c563a4c50a304324.png";